import styled from "@emotion/styled";
export const ActivityRoot = styled.div`
  margin: 0 4rem;
`;
export const ActivityHeader = styled.div`
  padding: 2rem 0;
`;
export const ActivityBody = styled.div`
  display: flex;
`;
export const ActivityMain = styled.div`
  width: 66.66%;
`;
export const ActivitySidebar = styled.div`
  width: 33.33%;
`;
